import { Component, Input, OnInit } from '@angular/core';
import { MDVoucher } from 'src/app/interfaces/api/voucher';

@Component({
  selector: 'app-my-voucher-card',
  templateUrl: './my-voucher-card.component.html',
  styleUrls: ['./my-voucher-card.component.scss'],
})
export class MyVoucherCardComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() data: MDVoucher;

  constructor() { }

  ngOnInit() { }

  isExpired() {
    var today = new Date();
    var expDate = new Date(this.data?.valid_until);
    if (today.getTime() > expDate.getTime()) {
      return true;
    }
    return false;
  }
}
